module.exports = {
  'Select your language': '選擇你的語言',

  'IFT Home Page': '旅遊學院主頁',
  'lang-en': 'English',
  'lang-zh': '繁體中文',

  'Address': '地址',
  'E-mail': '電郵',
  'Phone': '電話',
  'Fax': '傳真',
  'IFT address': '中國澳門望廈山',
  'Download Year Report': '下載完整旅遊學院2017/18年度報告',
  'Footer copyright text': '旅遊學院版權所有',

  'more': '了解更多',
  'year': '年',

  'Income and Expenditure': '財務收支報表',
  'Human Captional': '人員架構',
  'Items': '項目',
  'Total': '總數',
  'Actual expenditure': '實際開支',
  'Actual income': '實際收入',
  'Actual expenditure for fiscal year 2017': '2017財政年度實際支出',
  'Actual income for fiscal year 2017': '2017財政年度實際收入',
  'Full-time faculty statistics': '全職教員統計表',
  'Full-time staff statistics': '全職人員統計表',
  'Position': '職位',
  'Number of people': '人數',

  'Global Internship Providers in Academic Year 2017/18': '2017/18 學年的環球實習機構',
  'Provider Name': '機構名稱',
  'Country and Region': '國家及地區',
  'Vocational Trainees - Academic Year 2017/18 (by course categories)': '2017/18 學年專業培訓及課程(以課程範疇分類)',
  'Vocational Trainees - Academic Year 2017/18 (by course types)': '2017/18 學年專業培訓及課程(以課程類別分類)',
  'Course Categories': '課程範疇',
  'Course Types': '課程類別',
  'Trainees': '人次',
  'Candidates': '人次',
  'Occupational Assessment Candidates - Academic Year 2017/18': '2017/18 學年專業考核',

  'League of Elite': '精銳之師',
  'Global Links': '放眼天下',
  'Research': '學術研究',
  'Campus': '校園發展',
  'Tourism College': '旅遊高等學校',
  'Tourism and Hotel School': '旅遊及酒店業學校',
  'Appendices': '附錄',
}
